export default __webpack_public_path__ + "static/media/google.4d7d0ca3.png";